module.exports = __webpack_public_path__ + "media/Literaturapotheke im NDR.98c6bba2.mp3";